import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";
import { toast } from "react-toastify";
import authActions from "../../auth/actions";
import { v4 as uuidv4 } from "uuid";
import { formatByIdSaga } from "src/store/helpers/formatByIdSaga";
const RELATIVES_URL = "/services/rcp/profile/relatives/";
export function* getFindChildren() {
  yield takeLatest(CONSTANTS.GET_FIND_CHILDREN, function* () {
    try {
      yield put(actions.setFindChildren(null));

      const url = RELATIVES_URL + "findchildren";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setFindChildren(data));
    } catch (e) {
      yield put(actions.setFindChildren([]));
      console.error(e);
    }
  });
}
export function* getAddedChildren() {
  yield takeLatest(CONSTANTS.GET_ADDED_CHILDREN, function* () {
    try {
      yield put(actions.setAddedChildren(null));

      const url = RELATIVES_URL + "addedchildren?showAllChildren=true";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setAddedChildren(data));
    } catch (e) {
      yield put(actions.setAddedChildren([]));
      console.error(e);
    }
  });
}
export function* getAddchild(setLoading) {
  yield takeLatest(CONSTANTS.GET_ADD_CHILD, function* (action) {
    try {
      yield put(actions.setAddchild(false));

      const url = RELATIVES_URL + "addchild";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success) {
        toast.error(res.ExceptionMessage);
        yield put(actions.setAddchild(false, setLoading(false)));
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      }

      yield put(actions.setAddchild(true));
    } catch (e) {
      yield put(actions.setAddchild(undefined));
      console.error(e);
    }
  });
}
export function* getCheckChild() {
  yield takeLatest(CONSTANTS.GET_CHECK_CHILD, function* (action) {
    try {
      yield put(actions.setCheckChild(false));

      const url = RELATIVES_URL + "checkchild";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setCheckChild(res.data));

      if (!res.data) {
        yield put(actions.setCheckChild(null));
      }
    } catch (e) {
      yield put(actions.setCheckChild(undefined));
      console.error(e);
    }
  });
}
export function* getInsurerMobile() {
  yield takeLatest(CONSTANTS.GET_INSURER_MOBILE, function* () {
    try {
      yield put(actions.setInsurerMobile(null));

      const url = RELATIVES_URL + "insurermobile";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setInsurerMobile(data));
    } catch (e) {
      yield put(actions.setInsurerMobile([]));
      console.error(e);
    }
  });
}
export function* getSendOTPInsurer() {
  yield takeLatest(CONSTANTS.GET_SEND_OTP_INSURER, function* (action) {
    try {
      yield put(actions.setSendOTPInsurer(null));

      const url = RELATIVES_URL + "sendotptoinsurer";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      yield put(actions.setSendOTPInsurer(true));
    } catch (e) {
      yield put(actions.setSendOTPInsurer(false));
      console.error(e);
    }
  });
}
export function* getSwitchUser() {
  yield takeLatest(CONSTANTS.GET_SWITCH_USER, function* (action) {
    yield put(authActions.loading(true));

    try {
      const { data } = yield window.mainAxios.post(
        RELATIVES_URL + "switchuser",
        action.payload
      );

      if (data.success) {
        localStorage.setItem("act", data.data.accessToken);
        localStorage.setItem("rft", data.data.refreshToken);
        localStorage.setItem("alm", data.data.autoLogoutMinute);
        localStorage.setItem("ImageHasUpdated", uuidv4().toString());

        // yield put(authActions.loginSuccess({ UserName: action.pId }));
        // yield put(
        //   authActions.userMustChangePassword(data.data.userMustChangePassword)
        // );
        yield put(authActions.loading(false));
        yield put(actions.setSwitchUser(true));
      }
    } catch (e) {
      yield put(actions.setSwitchUser(false));

      const message = yield formatByIdSaga("notifications.wrongUserName");
      toast.error(message);

      console.log(e);
      yield put(authActions.loading(false));
    }
  });
}

export default function* relativesSaga() {
  yield all([
    fork(getFindChildren),
    fork(getAddedChildren),
    fork(getAddchild),
    fork(getCheckChild),
    fork(getInsurerMobile),
    fork(getSendOTPInsurer),
    fork(getSwitchUser),
  ]);
}
